import React from 'react';
import routes, { redirects } from './routes';
import { MyDataDashboardTemplate } from '../common/MyDataDashboardTemplate';
import DocumentWrapper from '../common/DocumentWrapper';
import { withTranslation } from '../../../../components/hoc';

const Personal = (props) => {
  return (
    <DocumentWrapper formTitle="Base">
      <MyDataDashboardTemplate
        {...props}
        showSideBar
        routes={routes}
        redirects={redirects}
        render={(renderPropsData) => (
          <MyDataDashboardTemplate.Main {...renderPropsData} card={false} />
        )}
      />
    </DocumentWrapper>
  );
};

export default withTranslation(Personal);
